import RemoteCall from "../../../util/RemoteCall";

const remoteCall = new RemoteCall("api/emp/archive/");

function findEmployeeByUnitAsync(param) {
    return remoteCall.invoke("findEmployeeByUnit", param);
}

function findEmployeeByRoleAsync(param) {
    return remoteCall.invoke("findEmployeeByRole", param);
}

function findBasicEmployeeTreeAsync(param) {
    return remoteCall.invoke("findBasicEmployeeTree", param);
}

function queryByFilterAsync(param) {
    return remoteCall.invoke("query", param);
}

// {userId}
const findByUserIdAsync = (params) => {
    return remoteCall.invoke("findByUserId", params);
};

const findByKwAsync = (param) => {
    return remoteCall.get("findByKw", param);
};

const getConfigAsync = (param) => {
    return remoteCall.invoke("getConfig", param);
};

const findAllAuthAsync = (param) => {
    return remoteCall.invoke("findAllAuth", param);
};

export default {
    findEmployeeByUnitAsync,
    findEmployeeByRoleAsync,
    findBasicEmployeeTreeAsync,
    findByUserIdAsync,
    queryByFilterAsync,
    findByKwAsync,
    getConfigAsync,
    findAllAuthAsync,
};
